import { observable, action } from 'mobx';
import agent from '../agent';
import commonStore from './commonStore';
import userStore from './userStore';

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export class AdminStore {
    @observable inProgress = false;
    @observable statusText;
    @observable errors;
    @observable addUserDialog = false;
    @observable changePasswordDialog = false;
    @observable pageNo = 0;
    @observable userMenuArray = [];
    @observable totalUsers = 0;
    @observable userList = [];
    @observable searchText = undefined;
    @observable blockDialog = false;
    @observable blockedList = [];
    @observable totalBlocked = 0;
    @observable ipMenuArray = [];
    @observable enterpriseList = [];
    @observable totalEnterprises = 0;
    @observable messageType = 'error'
    @observable tableHeader = [
        { name: 'Sr No.', type: 'serial', sort: 1, allowSort: false, width: '5vw' },
        { name: 'Name', type: 'userFullName', sort: 1, allowSort: true, width: '16vw' },
        { name: 'Enterprise', type: 'enterpriseId', sort: 1, allowSort: false, width: '10vw' },
        { name: 'Department', type: 'department', sort: 1, allowSort: true, width: '13vw' },
        { name: 'Domain', type: 'domain', sort: 1, allowSort: true, width: '10vw' },
        { name: 'Date Added', type: 'createdAt', sort: -1, allowSort: true, width: '13vw' },
        { name: 'Type', type: 'userType', sort: 1, allowSort: true, width: '13vw' },
        { name: 'IP', type: 'ip', sort: 1, allowSort: false, width: '10vw' },
    ];
    @observable ipTableHeader = [
        { name: 'Sr No.', type: 'serial', sort: 1, allowSort: false, width: '5vw', category: ['ip', 'domain'] },
        { name: 'IP', type: 'ip', sort: 1, allowSort: true, width: '16vw', category: ['ip'] },
        { name: 'Domain', type: 'domain', sort: 1, allowSort: true, width: '16vw', category: ['domain'] },
        { name: 'Created At', type: 'createdAt', sort: 1, allowSort: false, width: '10vw', category: ['ip', 'domain'] },
    ];
    @observable entTableHeader = [
        { name: 'Name', type: 'name', sort: 1, allowSort: true, width: '16vw' },
        { name: 'Docs Uploaded', type: 'totalUploads', sort: 1, allowSort: false, width: '8vw' },
        { name: 'Docs Exported', type: 'EXPORTED', sort: 1, allowSort: false, width: '8vw' },
        { name: 'Available Credits', type: 'creditsAvailable', sort: 1, allowSort: true, width: '10vw' },
        { name: 'No. Of Agents', type: 'AGENT', sort: 1, allowSort: false, width: '8vw' },
        { name: 'No. Of Admins', type: 'ADMIN', sort: 1, allowSort: false, width: '8vw' },
        { name: 'Created At', type: 'createdAt', sort: -1, allowSort: true, width: '10vw' },




    ]

    @action setPageNumber(num) {
        this.pageNo = num;
    }

    @action openUserMenu(e, index) {
        this.userMenuArray[index] = e.currentTarget
    }

    @action openIPMenu(e, index) {
        this.ipMenuArray[index] = e.currentTarget
    }

    @action openBlockDialog(value) {
        this.blockDialog = value;
    }

    @action sortUserList(sortField, sortDirection) {
        let index = this.tableHeader.findIndex(x => x.type === sortField);
        this.tableHeader.forEach((el) => { el.sort = 1 })
        this.tableHeader[index].sort = sortDirection;
        if (userStore.user.userType === 'SUPER_ADMIN')
            this.getGlobalUserList(false, sortField, sortDirection)
        else
            this.getUserList(false, sortField, sortDirection)
    }

    @action sortBlockedList(filter, sortField, sortDirection) {
        let index = this.ipTableHeader.findIndex(x => x.type === sortField);
        this.ipTableHeader.forEach((el) => { el.sort = 1 })
        this.ipTableHeader[index].sort = sortDirection;
        this.getBlockedList(filter, sortField, sortDirection)
    }

    @action sortEnterpriseList(sortField, sortDirection) {
        let index = this.entTableHeader.findIndex(x => x.type === sortField);
        this.entTableHeader.forEach((el) => { el.sort = 1 })
        this.entTableHeader[index].sort = sortDirection;
        this.getEnterpriseList(sortField, sortDirection)
    }

    @action getSortField() {
        let counts = this.tableHeader.reduce((c, { sort: key }) => (c[key] = (c[key] || 0) + 1, c), {});
        let sortDirection = (counts[-1] === 1) ? -1 : 1;
        let index = this.tableHeader.findIndex(x => x.sort === -1);
        if (index > -1)
            return { sortField: this.tableHeader[index].type, sortDirection: sortDirection }
        else {
            let index = this.tableHeader.findIndex(x => x.type === 'createdAt');
            this.tableHeader[index].sort = -1
            return { sortField: 'createdAt', sortDirection: sortDirection }

        }
    }

    @action getIpSortField() {
        let counts = this.ipTableHeader.reduce((c, { sort: key }) => (c[key] = (c[key] || 0) + 1, c), {});
        let sortDirection = (counts[-1] === 1) ? -1 : 1;
        let index = this.ipTableHeader.findIndex(x => x.sort === -1);
        if (index > -1)
            return { sortField: this.ipTableHeader[index].type, sortDirection: sortDirection }
        else {
            //let index = this.ipTableHeader.findIndex(x => x.type === 'createdAt');
            //this.ipTableHeader[index].sort = -1
            return { sortField: 'ip', sortDirection: sortDirection }

        }
    }

    @action getEntSortField() {
        let counts = this.entTableHeader.reduce((c, { sort: key }) => (c[key] = (c[key] || 0) + 1, c), {});
        let sortDirection = (counts[-1] === 1) ? -1 : 1;
        let index = this.entTableHeader.findIndex(x => x.sort === -1);
        if (index > -1)
            return { sortField: this.entTableHeader[index].type, sortDirection: sortDirection }
        else {
            let index = this.entTableHeader.findIndex(x => x.type === 'createdAt');
            this.entTableHeader[index].sort = -1
            return { sortField: 'createdAt', sortDirection: sortDirection }

        }
    }

    @action createUser(newUser) {
        this.inProgress = true;
        this.messageType = 'error';
        return agent.Admin.createUser(newUser)
            .then(action((response) => {
                this.openAddUserDialog(false);
                if (response.statusCode == "200") {
                    this.messageType = 'success'
                    this.pageNo = 0
                    if (userStore.user.userType === 'SUPER_ADMIN')
                        this.getGlobalUserList(false)
                    else
                        this.getUserList(false)
                }
                commonStore.handleOpenSnackBar(response.message, this.messageType);
            }))
            .catch(action((err) => {
                commonStore.handleOpenSnackBar("Failed to create user! ", this.messageType)
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action editUser(user) {
        this.inProgress = true;
        this.errors = undefined;
        this.messageType = 'error'
        return agent.Admin.editUser(user)
            .then(action((response) => {
                this.openAddUserDialog(false);
                if (response.statusCode == "200") {
                    this.messageType = 'success'
                    if (userStore.user.userType === 'SUPER_ADMIN')
                        this.getGlobalUserList(false)
                    else
                        this.getUserList(false)
                }
                commonStore.handleOpenSnackBar(response.message, this.messageType);

            }))
            .catch(action((err) => {
                commonStore.handleOpenSnackBar("Failed to edit user! ", this.messageType)
                //throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action resendUpdateVerificationEmail(user) {
        this.errors = undefined;
        this.messageType = "error"
        return agent.Admin.resendUpdateVerificationEmail(user.newEmail)
            .then(action((response) => {
                if (response.statusCode == '200')
                    this.messageType = "success"
                commonStore.handleOpenSnackBar(response.message, this.messageType);
            }))
            .catch(action((err) => {
                commonStore.handleOpenSnackBar("Failed to resend mail! ", 'error')
                //throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action createEnterprise(enterprise) {
        this.inProgress = true;
        this.errors = undefined;
        this.messageType = "error";
        return agent.Admin.createEnterprise(enterprise)
            .then(action((response) => {
                if (response.statusCode == '200')
                    this.messageType = "success"
                commonStore.handleOpenSnackBar(response.message, this.messageType);
            }))
            .catch(action((err) => {
                commonStore.handleOpenSnackBar("Failed to create enterprise! " , 'error')
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action resetSearch = () => {
        this.searchText = undefined
    }

    @action resetUserMenuArray() {
        this.userMenuArray = new Array(this.userList.length).fill(false);
    }

    @action resetIPMenuArray() {
        this.ipMenuArray = new Array(this.blockedList.length).fill(false);
    }

    @action getUserList(assignFlag, sortField, sortDirection) {
        this.inProgress = true;
        this.errors = undefined;
        let temp = { sortField, sortDirection }
        if (sortField === undefined)
            temp = this.getSortField()
        return agent.Admin.getUserList(assignFlag, temp.sortField, temp.sortDirection, this.searchText)
            .then(action((response) => {
                if (response.statusCode == 200) {
                    this.userList = response.data.userList;
                    this.totalUsers = response.data.totalUsers
                    this.resetUserMenuArray()
                }
            }))
            .catch(action((err) => {
                this.registerFailed = true;
                this.statusText = "Registration Failed";
                this.errors = err.response && err.response.body && err.response.body.errors;
                //throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action getGlobalUserList(assignFlag, sortField, sortDirection) {
        this.inProgress = true;
        this.errors = undefined;
        let temp = { sortField, sortDirection }
        if (sortField === undefined)
            temp = this.getSortField()
        return agent.SuperAdmin.getGlobalUserList(assignFlag, temp.sortField, temp.sortDirection, this.searchText)
            .then(action((response) => {
                if (response.statusCode == 200) {
                    this.userList = response.data.userList;
                    this.totalUsers = response.data.totalUsers
                    this.resetUserMenuArray()
                }
            }))
            .catch(action((err) => {
                this.registerFailed = true;
                this.statusText = "Registration Failed";
                this.errors = err.response && err.response.body && err.response.body.errors;
                //throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action searchUserList(assignFlag, searchFilter) {
        this.searchText = searchFilter;
        if (userStore.user.userType === 'SUPER_ADMIN')
            this.getGlobalUserList(assignFlag)
        else
            this.getUserList(assignFlag)
    }

    @action searchBlockedList(searchFilter, category) {
        this.searchText = searchFilter;
        this.getBlockedList(category)
    }

    @action searchEnterpriseList(searchFilter) {
        this.searchText = searchFilter;
        this.getEnterpriseList()
    }

    @action validateEmail(email) {
        if (!email || !emailRegex.test(email))
            return false;
        return true;
    }

    @action openAddUserDialog(value) {
        this.addUserDialog = value
    }

    @action openChangePasswordDialog(value) {
        this.changePasswordDialog = value
    }

    @action deleteUser(userId) {
        //this.inProgress = true;
        this.errors = undefined;
        return agent.Admin.deleteUser(userId)
            .then(action((response) => {
                if (response.statusCode == "200") {
                    if (userStore.user.userType === 'SUPER_ADMIN')
                        this.getGlobalUserList(false)
                    else
                        this.getUserList(false)
                }

            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action changePassword(userId, newPassword) {
        this.inProgress = true;
        this.messageType = 'error'
        return agent.Admin.changePassword(userId, newPassword)
            .then(action((response) => {
                if (response.statusCode == "200"){
                    this.openChangePasswordDialog(false)
                    this.messageType = 'success'
                }
                commonStore.handleOpenSnackBar(response.message, this.messageType)
            }))
            .catch(action((err) => {
                commonStore.handleOpenSnackBar('Failed to update password!', 'error')
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action blockIP(ip) {
        this.inProgress = true;
        this.errors = undefined;
        this.messageType = 'error'
        return agent.SuperAdmin.blockIP(ip)
            .then(action((response) => {
                this.openBlockDialog(false);
                if (response.statusCode == "200") {
                    this.messageType = 'success'
                    this.getGlobalUserList(false)
                    this.getBlockedList('IP')
                }
                commonStore.handleOpenSnackBar(response.message, this.messageType);

            }))
            .catch(action((err) => {
                commonStore.handleOpenSnackBar("Failed to block IP! ", 'error')
                this.errors = err.response && err.response.body && err.response.body.errors;
                //throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action unblockIP(ip, type) {
        this.inProgress = true;
        this.errors = undefined;
        this.messageType = 'error';
        return agent.SuperAdmin.unblockIP(ip)
            .then(action((response) => {
                this.openBlockDialog(false);
                if (response.statusCode == "200") {
                    this.messageType = 'success'
                    if (type)
                        this.getBlockedList(type)
                    else
                        this.getGlobalUserList(false)
                }
                commonStore.handleOpenSnackBar(response.message, this.messageType);
            }))
            .catch(action((err) => {
                commonStore.handleOpenSnackBar("Failed to unblock IP! ", 'error')
                //throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action blockDomain(domain) {
        this.inProgress = true;
        this.errors = undefined;
        this.messageType = 'error';
        return agent.SuperAdmin.blockDomain(domain)
            .then(action((response) => {
                this.openBlockDialog(false);
                if (response.statusCode == "200") {
                    this.messageType = 'success'
                    this.getBlockedList('DOMAIN')
                }
                commonStore.handleOpenSnackBar(response.message, this.messageType);
            }))
            .catch(action((err) => {
                commonStore.handleOpenSnackBar("Failed to block domain! ", 'error')
                //throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action unblockDomain(domain, type) {
        this.inProgress = true;
        this.errors = undefined;
        this.messageType = 'error';
        return agent.SuperAdmin.unblockDomain(domain)
            .then(action((response) => {
                this.openBlockDialog(false);
                if (response.statusCode == "200") {
                    this.messageType = 'success';
                    this.getBlockedList('DOMAIN')
                }
                commonStore.handleOpenSnackBar(response.message, this.messageType);

            }))
            .catch(action((err) => {
                commonStore.handleOpenSnackBar("Failed to unblock domain! ", 'error')
                //throw err;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }


    @action getBlockedList(category, sortField, sortDirection) {
        this.inProgress = true;
        this.errors = undefined;
        let temp = { sortField, sortDirection }
        if (sortField === undefined)
            temp = this.getIpSortField()
        return agent.SuperAdmin.getBlockedList(category, temp.sortField, temp.sortDirection, this.searchText)
            .then(action((response) => {
                if (response.statusCode == 200) {
                    this.blockedList = response.data.blockList;
                    this.totalBlocked = response.data.totalBlocked;
                    this.resetIPMenuArray()
                }
            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => { this.inProgress = false; }));
    }

    @action getEnterpriseList(sortField, sortDirection) {
        this.inProgress = true;
        this.errors = undefined;
        let temp = { sortField, sortDirection }
        console.log(temp)
        if (sortField === undefined)
            temp = this.getEntSortField()
        return agent.SuperAdmin.getEnterpriseList(temp.sortField, temp.sortDirection, this.searchText)
            .then(action((response) => {
                if (response.statusCode == 200) {
                    this.enterpriseList = response.data.enterpriseList;
                    this.totalEnterprises = response.data.totalEnterprise;
                    //this.resetUserMenuArray()
                }
            }))
            .catch(action((err) => {
                this.statusText = "Unable to fetch enterprises";
            }))
            .finally(action(() => { this.inProgress = false; }));
    }
}


export default new AdminStore();
